import React from 'react';
import { Route } from 'react-router';

import RouteWithSearch from 'lib/react-router/route-with-search';
import LoadingSwitch from 'lib/react-router/loading-switch';

import NotFound from 'four-nets/errors/404/not-found';
import AlbumDetailLoader from 'four-nets/photoblog/posts/album/detail/detail-loader';
import ImageLoader from 'four-nets/photoblog/image/image-loader';
import UserBlog from 'four-nets/photoblog/user-blog/user-blog';
import Article from 'four-nets/photoblog/article/article';
import CreateEditArticle from 'four-nets/photoblog/create-edit-article/create-edit-article';
import AlbumImagesEdit from 'four-nets/photoblog/posts/album/edit/images-edit/images-edit';
import AlbumImagesReorder from 'four-nets/photoblog/posts/album/edit/images-reorder/images-reorder';
import AlbumInfoEdit from 'four-nets/photoblog/posts/album/edit/info-edit/info-edit';
import ArticleEditLoader from 'four-nets/photoblog/create-edit-article/edit-loader';

import Vendors from './vendors/vendors';
import Catalog from './catalog/catalog';

class VendorRouter extends React.PureComponent {
    render() {
        return (
            <LoadingSwitch>
                <RouteWithSearch
                    path={'/catalog/vendor/:username/blog-album/:slug/edit'}
                    exact={true}
                    component={AlbumInfoEdit}
                />
                <RouteWithSearch
                    path={'/catalog/vendor/:username/blog-album/:slug/edit-photos'}
                    exact={true}
                    component={AlbumImagesEdit}
                />
                <RouteWithSearch
                    path={'/catalog/vendor/:username/blog-album/:slug/reorder'}
                    exact={true}
                    component={AlbumImagesReorder}
                />
                <Route
                    exact={true}
                    path='/catalog/vendor/:username/blog-album/:slug/:imageId(\d+)'
                    component={ImageLoader}
                />
                <RouteWithSearch
                    exact={true}
                    path='/catalog/vendor/:username/blog-album/:slug'
                    component={AlbumDetailLoader}
                />
                <RouteWithSearch path='/catalog/category/:slug' exact={true} component={Vendors} />
                <RouteWithSearch
                    path='/catalog/vendor/:username'
                    exact={true}
                    render={props => <UserBlog {...props} isVendor={true} />}
                />
                <Route path='/catalog/vendor/:username/:imageId(\d+)' exact={true} component={ImageLoader} />
                <RouteWithSearch
                    path='/catalog/vendor/:username/add/article'
                    exact={true}
                    component={CreateEditArticle}
                />
                <RouteWithSearch
                    path='/catalog/vendor/:username/article/:slug/edit'
                    exact={true}
                    component={ArticleEditLoader}
                />
                <RouteWithSearch path='/catalog/vendor/:username/article/:slug' exact={true} component={Article} />
                <Route path='/catalog' exact={true} component={Catalog} />
                <Route component={NotFound} />
            </LoadingSwitch>
        );
    }
}

export default VendorRouter;
